import { Typography, useTheme } from '@mui/material';
import { TagChip } from 'components/ui';
import { TableContext } from 'pages/PatientsPage';
import { alertsList } from 'pages/PatientsPage/PatientsFilter/Filters/AlertsFilter';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const AlertFilterChip = () => {
  const { t } = useTranslation();
  const theme = useTheme()
  const { filters, setFilters } = useContext(TableContext);

  function deleteFilter(alert) {
    setFilters({
      ...filters,
      [alert]: false,
    });
  }

  return alertsList?.map((alert) =>
    filters?.[alert.value] ? (
      <TagChip
        key={alert.value}
        tag={
          <>
            <Typography
              component="span"
              color={theme.palette.colors.black}
              fontSize={'0.875rem'}
              fontWeight={'500'}
            >
              {`${t('Alerts')}: `}
            </Typography>
            <Typography
              component="span"
              color={theme.palette.colors.blue100}
              fontSize={'0.875rem'}
              fontWeight={'500'}
            >
              {t(alert.label)}
            </Typography>
          </>
        }
        handleDelete={() => deleteFilter(alert.value)}
        isCanDelete
        iconColor={theme.palette.colors.blue100}
      />
    ) : null
  );
};
